import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './plugins/router'
import i18n from './plugins/i18n'
import store from './plugins/store'
import backendAPI from './plugins/axios'
import MobileDetect from 'mobile-detect'
import './registerServiceWorker'

Vue.prototype.$http = backendAPI

Vue.prototype.$mobileDetect = new MobileDetect(window.navigator.userAgent)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
